module.exports = __webpack_public_path__ + "img/5f_r_kandagawa.0c9ecd5c.jpg";